import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import upload from './modules/upload';
import course from './modules/course';
import home from './modules/home';
import menu from './modules/menu';
import manage from './modules/manage';
import backend from './modules/backend';
import notice from './modules/notice';
import getters from './getter';
import common from './modules/common';
import media from './modules/media';
import personCenter from './modules/personCenter';

Vue.use(Vuex);
const store= new Vuex.Store({
    modules:{
        user,
        upload,
        home,
        menu,
        common,
        backend,
        course,
        manage,
        notice,
        media,
        personCenter
    },
    getters
});

export default store



